var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAxionAcceleratorSupernova(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 773.8 156",
    style: {
      enableBackground: "new 0 0 773.8 156"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FF8500;}\n\t.st1{fill:#FFDA00;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000125593930514818246530000004335014000185498771_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.4,85.3V68.3h16.5L48.4,25.6L25.1,85.3H5.7L39.8,0h17.1L91,85.3H48.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M208.4,42.7L176.4,0h21.3l21.3,28.5L240.4,0h21.3l-32,42.7l32,42.7h-21.3l-21.3-28.5l-21.3,28.5h-21.3 L208.4,42.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M398.3,0v85.3h-17.1V0H398.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M517.8,85.3V0h85.3v85.3H517.8z M586.1,68.3V17.1h-51.2v51.2H586.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M688.5,85.3V0h17.1l51.2,60.5V0h17.1v85.3h-17.1l-51.2-58.7v58.7H688.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18.2,156l1.9-7.3h7.1L25,130.5L8.3,156H0l24.3-36.4h7.3l4.8,36.4H18.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M82.5,119.6h36.4l-1.9,7.3H87.9L82,148.7h29.1l-2,7.3H72.8L82.5,119.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M155.3,119.6h36.4l-1.9,7.3h-29.1l-5.9,21.8h29.1l-1.9,7.3h-36.4L155.3,119.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M231.5,134.1h21.8l-1.9,7.3h-21.8l-2,7.3h29.1l-2,7.3h-36.4l9.8-36.4h36.4l-1.9,7.3h-29.1L231.5,134.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M327.4,156H291l9.8-36.4h7.3l-7.8,29.1H322l2-7.3h7.3L327.4,156z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M377,134.1h21.8l-1.9,7.3H375l-2,7.3h29.1l-2,7.3h-36.4l9.8-36.4H410l-2,7.3h-29.1L377,134.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M455.1,141.4h-7.3l-4,14.6h-7.3l9.8-36.4h36.4l-5.8,21.8h-12.8l8.9,14.6h-9L455.1,141.4z M451.7,126.9 l-1.9,7.3h21.8l1.9-7.3L451.7,126.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M527.5,156l1.9-7.3h7l-2.2-18.2L517.6,156h-8.3l24.3-36.4h7.3l4.8,36.4H527.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M591.8,119.6h36.4l-1.9,7.3h-14.5l-7.8,29.1h-7.3l7.8-29.1h-14.6L591.8,119.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M701,119.6l-9.8,36.4h-36.4l9.8-36.4L701,119.6z M670,126.9l-6,21.8h21.8l5.9-21.8H670z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M746.1,141.4h-7.3l-4,14.6h-7.3l9.8-36.4h36.4l-5.7,21.8h-12.9L764,156h-9L746.1,141.4z M742.7,126.9 l-1.9,7.3h21.8l1.9-7.3L742.7,126.9z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAxionAcceleratorSupernova);
export default __webpack_public_path__ + "static/media/AxionAccelerator_Supernova.6144e26929dad1f3baf389e1fd062492.svg";
export { ForwardRef as ReactComponent };